<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ai7esL/tc-custom/9781504076272.jpg?1726454433035" alt="This image is the cover for the book Cursing Stones Murder, The Inspector Littlejohn Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cursing Stones Murder, The Inspector Littlejohn Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A body surfaces off the Isle of Man in a puzzling mystery by the master of the “pure British detective story” (<i>The New York Times</i>).</b><br/>  <br/> The <i>Manx Shearwater</i> was scallop dredging—but it dragged up a body from the water instead. Considering that the corpse was tied at the ankles and weighed down with stones, it’s clear this was no accidental drowning—and now the locals are in an uproar.<br/>  <br/> The victim appears to be Cedric Levis, who had an extravagant house and a reputation for philandering. Was Levis murdered for his money—or was this a crime of passion? Under the pretext of a holiday, Chief Inspector Littlejohn is invited by his old friend Archdeacon Kinrade to unofficially assist with the murder investigation—but to separate fact from fiction, he’ll have to sort through accusations, town gossip, and mysterious stories surrounding the ancient Cursing Stones . . .<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Bellairs
      </h2>
      
      <p class="authorDescription body article">George Bellairs was the pseudonym of Harold Blundell (1902&ndash;1985), an English crime author best known for the creation of Detective-Inspector Thomas Littlejohn. Born in Heywood, near Lancashire, Blundell introduced his famous detective in his first novel, <I>Littlejohn on Leave</I> (1941). A low-key Scotland Yard investigator whose adventures were told in the Golden Age style of Agatha Christie and Dorothy L. Sayers, Littlejohn went on to appear in more than fifty novels, including <I>The Crime at Halfpenny Bridge</I> (1946), <I>Outrage on Gallows Hill </I>(194<a>9</a>), and <I>The Case of the Headless Jesuit</I> (1950).<BR /><BR /> In the 1950s Bellairs relocated to the Isle of Man, a remote island in the Irish Sea, and began writing full time. He continued writing Thomas Littlejohn novels for the rest of his life, taking occasional breaks to write standalone novels, concluding the series with <I>An Old Man Dies</I> (1980).<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Agora Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ee0f1cae